import React, { useEffect, useState } from 'react';
import HubSpotAuth from '../services/hubspotAuth';

const OAuthCallback = () => {
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState('');

  useEffect(() => {
    handleOAuthCallback();
  }, []);

  const handleOAuthCallback = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');

      if (!code) {
        setError('No authorization code received');
        setStatus('error');
        return;
      }

      const auth = new HubSpotAuth();
      const tokenData = await auth.exchangeCodeForToken(code);

      setStatus('success');

      // Redirect back to main app or close window
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);

    } catch (err) {
      console.error('OAuth callback error:', err);
      setError(err.message);
      setStatus('error');
    }
  };

  const getAuthUrl = () => {
    const auth = new HubSpotAuth();
    return auth.getAuthorizationUrl();
  };

  if (status === 'processing') {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <h2>Processing OAuth...</h2>
          <p>Please wait while we complete your authentication.</p>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <h2>Authentication Error</h2>
          <p>{error}</p>
          <button
            onClick={() => window.location.href = getAuthUrl()}
            style={styles.button}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h2>Authentication Successful!</h2>
        <p>You have been successfully authenticated with HubSpot.</p>
        <p>Redirecting to dashboard...</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
  },
  content: {
    textAlign: 'center',
    background: 'rgba(255, 255, 255, 0.1)',
    padding: '40px',
    borderRadius: '12px',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)'
  },
  button: {
    background: '#00d4ff',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '12px 24px',
    fontSize: '16px',
    cursor: 'pointer',
    marginTop: '20px'
  }
};

export default OAuthCallback;